module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "break z"
  }), _vm._v(" "), _c('p', {
    staticClass: "noind s"
  }, [_c('b', [_vm._v("prepper")])]), _vm._v(" "), _c('p', {
    staticClass: "noind s"
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("noun")])]), _vm._v(" "), _c('p', {
    staticClass: "noind s"
  }, [_vm._v("prep· per | \\ ˈpre-pər  \\")]), _vm._v(" "), _c('p', {
    staticClass: "noind s"
  }, [_c('i', [_vm._v("plural ")]), _c('b', [_vm._v("preppers")])]), _vm._v(" "), _c('p', {
    staticClass: "noind s"
  }, [_c('b', [_vm._v("Definition of "), _c('i', [_vm._v("prepper")])])]), _vm._v(" "), _c('p', {
    staticClass: "noind s"
  }, [_c('b', [_vm._v(":  ")]), _vm._v("a  person  who  prepares  something  or  prepares  for something a food/mea "), _c('i', [_vm._v("prepper ")]), _vm._v("a hair "), _c('i', [_vm._v("prepper specifically")]), _c('b', [_vm._v(": ")]), _vm._v("a person who gathers materials and makes plans in preparation for surviving a major disaster or cataclysm (such as worldwide economic collapse or war) doomsday "), _c('i', [_vm._v("preppers ")]), _vm._v("I consider myself something of a "), _c('i', [_vm._v("prepper")]), _vm._v(". I don’t necessarily believe there is an apocalypse coming anytime soon. However, there are certain items I always keep on hand just in case. — Jennifer Wyatt Emory")]), _vm._v(" "), _c('p', {
    staticClass: "noind z"
  }, [_c('b', [_vm._v("First Known Use of "), _c('i', [_vm._v("prepper")])])]), _vm._v(" "), _c('p', {
    staticClass: "noind s"
  }, [_vm._v("1904, in the meaning defined "), _c('span', {
    staticClass: "underline"
  }, [_vm._v("above")])]), _vm._v(" "), _c('p', {
    staticClass: "noind s"
  }, [_c('a', {
    staticClass: "underline",
    attrs: {
      "href": "http://www.merriam-webster.com/dictionary/prepper",
      "target": "_blank"
    }
  }, [_vm._v("https://www.merriam-webster.com/dictionary/prepper")])]), _vm._v(" "), _c('p', {
    staticClass: "ind z"
  }, [_vm._v("While  this  is  the  “technical”  definition,  it  does  not  encompass fully what we do, we must always be ready for any situation which may arise. That includes the equipment to get home, to get out, and the mental fortitude to handle any situation life, or the world, should throw at us. While in theory, it may not sound difficult, if you ever find yourself in a truly stressful situation, can  you do it without the shakes from the adrenaline rush? This is what Prepping is truly about. The gear and the mentality.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2b4e6c80","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/04_pro.vue
// module id = 66
// module chunks = 0